import React from "react";
import Product from "../Components/Product/ProductMain/Product";

const ProductDetails = () => {
  return (
    <Product />
  );
};

export default ProductDetails;